import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { MapEvent, MapEventType } from '../model/map-event';
import { Positionable } from '../model/positionable';
import { LatLng } from 'leaflet';

@Injectable()
export class MapEventService {
  selectedCircle(key: string, point: LatLng, radius: number): void {
    this.mapEventsSubscription.next({
      type: MapEventType.SELECTED_CIRCLE,
      data: { key, point, radius }
    });
  }

  private mapEventsSubscription = new Subject<MapEvent<any>>();
  events$ = this.mapEventsSubscription.asObservable();

  centerOnMap(data: Positionable, zoom: number = 16): void {
    this.mapEventsSubscription.next({
      type: MapEventType.CENTER_ON_MAP,
      data: {
        latLng: data.getPosition(),
        zoom
      }
    });
  }

  centerElementOnMap(dataType: string, data: any): void {
    this.mapEventsSubscription.next({
      type: MapEventType.CENTER_ELEMENT_ON_MAP,
      data: {
        dataType,
        data
      }
    });
  }

  // Domyślne 2400 ms to czas dwóch pierścieni pingu (patrz .marker-ping w map-styles.scss) plus chwila
  // na dojście wzrokiem. Dłużej nie warto - powiększony marker zasłania sąsiadów.
  enlargeOnMap(dataType: string, data: any, timeMillis: number = 2400, revealClustered: boolean = true): void {
    this.mapEventsSubscription.next({
      type: MapEventType.ENLARGE_ON_MAP,
      data: {
        dataType,
        data,
        timeMillis,
        revealClustered
      }
    });
  }

  enableDrawPolygon(key: string): void {
    this.mapEventsSubscription.next({
      type: MapEventType.ENABLE_DRAW_POLYGON,
      data: { key }
    });
  }

  cancelDrawPolygon(key: string): void {
    this.mapEventsSubscription.next({
      type: MapEventType.DISABLE_DRAW_POLYGON,
      data: { key }
    });
  }

  clearPolygon(key: string): void {
    this.mapEventsSubscription.next({
      type: MapEventType.CLEAR_POLYGON,
      data: { key }
    });
  }

  selectedPolygon(key: string, points: L.LatLng[]): void {
    this.mapEventsSubscription.next({
      type: MapEventType.SELECTED_POLYGON,
      data: { key, points }
    });
  }

  enableDrawRectangle(key: string): void {
    this.mapEventsSubscription.next({
      type: MapEventType.ENABLE_DRAW_RECT,
      data: { key }
    });
  }

  cancelDrawRectangle(key: string): void {
    this.mapEventsSubscription.next({
      type: MapEventType.DISABLE_DRAW_RECT,
      data: { key }
    });
  }

  clearRectangle(key: string): void {
    this.mapEventsSubscription.next({
      type: MapEventType.CLEAR_RECT,
      data: { key }
    });
  }

  cancelAndClearRectangle(key: string): void {
    this.cancelDrawRectangle(key);
    this.clearRectangle(key);
  }

  selectedRectangle(key: string, point1: L.LatLng, point2: L.LatLng): void {
    this.mapEventsSubscription.next({
      type: MapEventType.SELECTED_RECT,
      data: { key, point1, point2 }
    });
  }

  enableDrawCircle(key: string): void {
    this.mapEventsSubscription.next({
      type: MapEventType.ENABLE_DRAW_CIRCLE,
      data: { key }
    });
  }

  cancelAndClearCircle(key: string): void {
    this.cancelDrawCircle(key);
    this.clearCircle(key);
  }

  clearCircle(key: string): void {
    this.mapEventsSubscription.next({
      type: MapEventType.CLEAR_CIRCLE,
      data: { key }
    });
  }

  cancelDrawCircle(key: string): void {
    this.mapEventsSubscription.next({
      type: MapEventType.DISABLE_DRAW_CIRCLE,
      data: { key }
    });
  }
}
